import { Select } from "radix-ui";
import { cn } from "../../../../helpers/utils";

export default function SelectItem({ value, children }) {
  return (
    <Select.Item
      value={value}
      className={cn(
        "relative flex cursor-pointer select-none items-center rounded px-2 py-1.5 text-sm outline-none",
        "font-medium text-gray-700 hover:bg-gray-100",
        "data-[state=checked]:font-semibold data-[state=checked]:text-gray-900"
      )}
    >
      <Select.ItemText>{children}</Select.ItemText>
    </Select.Item>
  );
}
